import * as d3d from "d3-delaunay";
import {IPoint} from "../interfaces/IPoint";

export class Delaunay {

    public static from(pointList: IPoint[]): Delaunay {
        const rawDelaunay = d3d.Delaunay.from(pointList.map((e) => [e.lat, e.lon]));

        return new Delaunay(rawDelaunay);
    }

    public static fromDuetList(duetList: Array<Array<[number, number]>>) {
        const rawDelaunay = d3d.Delaunay.from(duetList);

        return new Delaunay(rawDelaunay);
    }

    private readonly rawDelaunay: any;

    constructor(rawDelaunay: any) {
        this.rawDelaunay = rawDelaunay;
    }

    public getRawDelaunay() {
        return this.rawDelaunay;
    }

    public find(x: number, y: number) : number {
        return this.rawDelaunay.find(x, y);
    }
}
